import type { LimitSource } from '@/lib/api/generated/model';

/**
 * Reading a concurrency limit somebody typed (spec 115 FR-010).
 *
 * A whole number from 1 to the ceiling — the service's own rule (spec 109), checked
 * here so the refusal arrives beside the field rather than as a failed save. Digits
 * only: `1.5`, `5e1` and `+3` are all things `Number()` would accept and a person did
 * not mean as a count of runs.
 */
export type ConcurrencyLimitInput =
  | { readonly ok: true; readonly value: number }
  | { readonly ok: false; readonly reason: string };

const DIGITS = /^\d+$/;

export function parseConcurrencyLimit(
  input: string,
  ceiling: number,
): ConcurrencyLimitInput {
  const trimmed = input.trim();
  const value = DIGITS.test(trimmed) ? Number(trimmed) : NaN;
  if (Number.isInteger(value) && value >= 1 && value <= ceiling) {
    return { ok: true, value };
  }
  return { ok: false, reason: `A whole number from 1 to ${ceiling}` };
}

/** Where a workspace's limit comes from, in the words the Limits page uses. */
export const LIMIT_SOURCE_WORDS: Record<LimitSource, string> = {
  workspace: 'Override',
  organization: 'Organization default',
  fallback: 'Installation default',
};
